import { FC } from "react";
import { useTranslation } from "react-i18next";

import { errors, RideBookingsRouteMismatchSummary } from "@ryde/shared";

import { RideBookingsRouteMismatchTooltipStyled } from "./ride-tabs.styled";

export type RideTabsBottomBookingsMismatchTooltipContentProps = {
  mismatchSummary: RideBookingsRouteMismatchSummary;
};

/** Tooltip: up to two short sentences with comma-separated booking / passenger ids. */
export const RideTabsBottomBookingsMismatchTooltipContent: FC<
  RideTabsBottomBookingsMismatchTooltipContentProps
> = ({ mismatchSummary }) => {
  const { t } = useTranslation();
  const {
    routeBookingIdsMissingFromRide,
    routePassengerIdsWithoutRideBooking,
    bookingIdsOnRideNotOnRoutePassengers,
  } = mismatchSummary;

  const fromRouteParts: string[] = [];
  if (routeBookingIdsMissingFromRide.length > 0) {
    fromRouteParts.push(
      t(errors.ride.bookingsMismatchRouteBookingsMissingOnRide, {
        ids: routeBookingIdsMissingFromRide.join(", "),
      }),
    );
  }
  if (routePassengerIdsWithoutRideBooking.length > 0) {
    fromRouteParts.push(
      t(errors.ride.bookingsMismatchRoutePassengersNoRideBooking, {
        ids: routePassengerIdsWithoutRideBooking.join(", "),
      }),
    );
  }
  const fromRouteText = fromRouteParts.join(" ");

  const onRideText =
    bookingIdsOnRideNotOnRoutePassengers.length > 0
      ? t(errors.ride.bookingsMismatchRideBookingsNotOnRoutePassengers, {
          ids: bookingIdsOnRideNotOnRoutePassengers.join(", "),
        })
      : "";

  if (!fromRouteText && !onRideText) {
    return t(errors.ride.bookingsMismatchRouteTooltipFallback);
  }

  const combined = [fromRouteText, onRideText].filter(Boolean).join(" ");

  return (
    <RideBookingsRouteMismatchTooltipStyled>
      {combined}
    </RideBookingsRouteMismatchTooltipStyled>
  );
};
